import React from "react";
import DataComponent from "../DataComponent";
import ToolTip from "../ToolTip/ToolTip";
import { get, isArray, isFunction } from "lodash-es";
import { classnames } from "../../utils/text";
import { getAddSizeUnit } from "../../utils/size";
import Button from "../Button";

const FormItem = (props) => {
  const {
    field,
    isHide,
    setForm,
    labelWidth = 100,
    style,
    form,
    onChange,
    errors,
    className,
    isRequiredShow,
    ...prop
  } = props;

  const title = get(field, "title", false);
  const titleBefore = get(field, "titleBefore", "");
  const titleAfter = get(field, "titleAfter", "");
  const tooltip = get(field, "tooltip", false);
  const tooltipPosition = get(field, "tooltipPosition", "bottom");

  const setEditorMode = () => {
    const fullScreenBtn = document.querySelectorAll('[aria-label="Full screen"]')[0];
    if (fullScreenBtn) {
      fullScreenBtn.click()
    }
  }
  return (isFunction(isHide) && isHide(props)) ||
    (!isFunction(isHide) && isHide) ? (
    <></>
  ) : (
    <div
      className={classnames(
        "data-form-item",
        {
          "none-title": title === false,
        },
        className
      )}
      style={style}
    >
      {get(field, "title") && (
        <label
          className={`data-form-label data-form-label-${get(field, "type")}`}
          style={{
            ...(get(field, "fullWidth")
              ? { width: "100%" }
              : { width: getAddSizeUnit(labelWidth) }),
            ...(field.titlestyle ? field.titlestyle : {}),
          }}
        >
          {/* <span className="field-title" dangerouslySetInnerHTML={{ __html: title }}></span> */}
          <span className="field-title">
            {titleBefore}
            {title}
            {titleAfter}
            {tooltip && (
              <>
                <ToolTip position={tooltipPosition} tooltiptext={tooltip} />
              </>
            )}
          </span>
          {isRequiredShow ? (
            prop.mode === "create" || prop.mode === "modify" ? (
              get(field, "required") && (
                <span className="color-red-100">&nbsp;*</span>
              )
            ) : (
              <></>
            )
          ) : (
            !get(field, "required") &&
            (get(field, "fullWidth") ? (
              <span className="label-sub">(선택)</span>
            ) : (
              <p className="label-sub">(선택)</p>
            ))
          )}

          {field && field.type === 'editor' &&
            <>
              <br />
              <Button action={setEditorMode} color="text" className={'color-main-100'} style={{ padding: 0, fontSize: '10px' }}>에디터모드</Button>
            </>
          }
        </label>
      )}
      <div
        className="form-component"
        style={
          get(field, "fullWidth")
            ? { width: "100%" }
            : { width: `calc(100% - ${getAddSizeUnit(labelWidth)})` }
        }
      >
        <DataComponent
          setForm={setForm}
          field={field}
          form={form}
          data={form}
          onChange={onChange}
          className={field.className}
          options={field.options || {}}
          {...prop}
        />
      </div>
      {errors && errors[field.key] && (
        <div className="message">
          {isArray(errors[field.key]) ? (
            errors[field.key].map((error, idx) => (
              <p className="error-message" key={idx}>
                {error}
              </p>
            ))
          ) : (
            <p className="error-message">{errors[field.key]}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default FormItem;
